import React, { useState } from 'react';
import './room4.css';

const TOOLS = [
  { id: 'wrench', name: 'Wrench', match: 'pipe' },
  { id: 'oilcan', name: 'Oil Can', match: 'hinge' },
  { id: 'chisel', name: 'Chisel', match: 'panel' },
];

const TARGETS = [
  { id: 'pipe', name: 'Rusted Pipe' },
  { id: 'hinge', name: 'Stiff Hinge' },
  { id: 'panel', name: 'Loose Panel' },
];

const ToolboxPuzzle = ({ onClose, onSolve }) => {
  const [matches, setMatches] = useState({ pipe: null, hinge: null, panel: null });
  const [selectedTool, setSelectedTool] = useState(null);
  const [error, setError] = useState(false);
  const [solved, setSolved] = useState(false);

  const placeTool = (targetId) => {
    if (!selectedTool) return;

    if (selectedTool.match === targetId) {
      const updated = { ...matches, [targetId]: selectedTool };
      setMatches(updated);
      setSelectedTool(null);

      const allMatched = TARGETS.every((t) => updated[t.id]);
      if (allMatched) {
        setSolved(true);
        setTimeout(() => {
          onSolve();
        }, 2000);
      }
    } else {
      setError(true);
      setTimeout(() => setError(false), 800);
      setSelectedTool(null);
    }
  };

  const remainingTools = TOOLS.filter(
    (t) => !Object.values(matches).some((m) => m?.id === t.id)
  );

  return (
    <div className="puzzleoverlay" onClick={onClose}>
      <div
        className={`puzzlemodal toolboxmodal ${error ? 'puzzleshake' : ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="puzzleclose" onClick={onClose}>✕</button>

        <h2 className="puzzletitle">THE TOOLBOX</h2>
        <p className="puzzlesubtitle">
          An open toolbox rests on the cabinet. Use each tool where it belongs.
        </p>

        <div className="maskinventory">
          {remainingTools.map((tool) => (
            <button
              key={tool.id}
              className={`maskbtn ${selectedTool?.id === tool.id ? 'selected' : ''}`}
              onClick={() => setSelectedTool(tool)}
            >
              <span className="placemasktext">{tool.name}</span>
            </button>
          ))}
          {remainingTools.length === 0 && !solved && (
            <span className="placemasktext">All tools in use...</span>
          )}
        </div>

        <div className="maskslots">
          {TARGETS.map((target) => (
            <div
              key={target.id}
              className="maskslot"
              onClick={() => placeTool(target.id)}
            >
              {matches[target.id] ? (
                <span className="placemasktext">{matches[target.id].name} used</span>
              ) : (
                <span className="placemasktext">{target.name}</span>
              )}
            </div>
          ))}
        </div>

        {error && <p className="puzzleerror">That tool won't help here.</p>}

        {solved && (
          <div className="successmessage">
            <h3>Everything is fixed in place.</h3>
            <p>The cabinet no longer rattles when you touch it.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ToolboxPuzzle;
